"use strict";

import "@/pages/top-mv";
import "@/pages/top-slider";
import "@/pages/career";
import "@/pages/careerMessage";
import "@/pages/careerGrowth";
import "@/pages/company";
import "@/pages/serviceCase-form";
import "@/modules/c-btnEntry";
import "@/modules/c-movie";
import "@/modules/c-slider";
import "@/modules/c-sliderList";
import "@/modules/c-sliderMemberList";
import "@/modules/c-sliderPhoto";
import "@/modules/c-serviseClientSlider";
import "@/modules/c-stickyMenu";
import "@/modules/header.js";
import "@/modules/gnav.js";
import "@/modules/footer.js";
import "@/modules/symbol.js";
import "@/modules/c-project-accordion";
import "@/modules/c-postContentShare";
import "@/modules/c-animationIn";
import "@/modules/c-scrollEn";